import type { RouteRecordRaw } from 'vue-router';
import { RouterView } from 'vue-router';
import { courseRoute } from './course';
import { profileRoute } from './profile';
import { languageRoutes } from './language';
import { programRoutes } from './program';
import { facultyRoutes } from './faculty';
import { degreeRoutes } from './degree';
import { thesisProposalRoutes } from './thesisProposal';
import { supervisionRoutes } from './supervision';
import { thesisProposalEvaluationRoutes } from './thesisProposalEvaluation';
import { teachingPracticeRoutes } from './teachingPractice';
// import { courseInstanceCategoriesRoutes } from './courseInstanceCategories';

import ResolveRoute from 'pages/ResolveRoute.vue';
import ErrorNotFound from 'pages/ErrorNotFound.vue';

const moreRoutes: RouteRecordRaw[] = [];

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', redirect: { name: 'MyFeed' } },
      {
        name: 'MyFeed',
        path: 'feed',
        component: () => import('pages/MyFeed.vue'),
      },
      {
        name: 'TimeScheduler',
        path: 'time_scheduler',
        component: () => import('pages/TimeScheduler.vue'),
      },
      {
        name: 'MySchedule',
        path: 'schedule',
        component: () => import('pages/MySchedule.vue'),
      },

      {
        name: 'MyStudyPlan',
        path: 'study_plan',
        component: () => import('pages/MyStudyPlan.vue'),
        children: [
          {
            path: ':id',
            name: 'MyStudyPlanDetail',
            component: () => import('pages/studyPlan/StudyPlanPage.vue'),
          },
          {
            path: ':id/compare',
            name: 'MyStudyPlanCompare',
            component: () => import('pages/studyPlan/StudyPlanCompare.vue'),
          },
        ],
      },
      {
        name: 'MyArchive',
        path: 'archive',
        component: () => import('pages/MyArchive.vue'),
      },
      {
        name: 'MyForm',
        path: 'form',
        component: () => import('pages/MyForm.vue'),
      },
      {
        name: 'MyFormTypeFill',
        path: 'form/:id',
        component: () => import('pages/appformtype/FillPage.vue'),
      },
      {
        name: 'MyThesis',
        path: 'thesis',
        redirect: { name: 'MyThesisList' },
        component: RouterView,
        children: [
          {
            path: '',
            name: 'MyThesisList',
            component: () => import('pages/MyThesis.vue'),
            meta: {
              breadcrumb: [
                { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
              ],
            },
          },
          {
            path: 'show/:id',
            name: 'ThesisShow',
            component: () => import('pages/thesis/ShowPage.vue'),
            meta: {
              breadcrumb: [
                { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
                { icon: 'visibility', label: 'Details' },
              ],
            },
          },
        ],
      },
      {
        name: 'AddAndSwap',
        path: 'add_and_swap',
        component: () => import('pages/AddAndSwap.vue'),
        meta: {
          breadcrumb: [{ icon: 'home', label: 'Add and Swap' }],
        },
      },
      {
        name: 'MyEnrollmentRequests',
        path: 'enrollment_requests',
        component: () => import('pages/MyEnrollmentRequests.vue'),
        meta: {
          breadcrumb: [{ icon: 'home', label: 'My Enrollment Requests' }],
        },
      },

      courseRoute,
      profileRoute,
      languageRoutes,
      programRoutes,
      facultyRoutes,
      degreeRoutes,
      supervisionRoutes,
      // courseInstanceCategoriesRoutes,
      teachingPracticeRoutes,
      thesisProposalRoutes,
      thesisProposalEvaluationRoutes,
      ...moreRoutes,
      {
        name: 'ThesisCommitteeRecommendationList',
        path: 'thesis_committee_recommendation',
        component: () =>
          import('pages/thesisCommitteeRecommendation/ListPage.vue'),
        meta: {
          breadcrumb: [
            { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
            {
              icon: 'assignment',
              label: 'Committee Recommendation',
            },
          ],
        },
      },
      {
        name: 'ThesisCommitteeRecommendationDetails',
        path: 'thesis_committee_recommendation/:id',
        component: () =>
          import('pages/thesisCommitteeRecommendation/DetailsPage.vue'),
        meta: {
          breadcrumb: [
            { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
            {
              icon: 'assignment',
              label: 'Committee Recommendation',
              to: { name: 'ThesisCommitteeRecommendationList' },
            },
            { icon: 'visibility', label: 'Details' },
          ],
        },
      },

      {
        name: 'SupervisionRequestDetails',
        path: 'supervision_request/:thesisId',
        component: () => import('pages/supervision_request/DetailsPage.vue'),
        meta: {
          breadcrumb: [
            { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
            {
              icon: 'supervisor_account',
              label: 'Supervision Request',
              to: { name: 'SupervisionRequest' },
            },
            {
              icon: 'visibility',
              label: 'Details',
            },
          ],
        },
      },

      {
        name: 'SupervisionRevisionDetails',
        path: 'supervision_revision/:thesisId',
        component: () =>
          import('pages/supervision/SupervisionRevisionDetails.vue'),
      },
    ],
  },
  {
    path: '/survey',
    component: () => import('layouts/FullWidthLayout.vue'),
    children: [
      {
        path: '',
        name: 'ListSurvey',
        component: () => import('pages/survey/ListPage.vue'),
      },
      {
        path: ':id',
        name: 'ShowSurvey',
        component: () => import('pages/survey/ShowPage.vue'),
      },
    ],
  },
  {
    path: '/resolve_route',
    component: ResolveRoute,
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: ErrorNotFound,
  },
];

export default routes;
